import { render, staticRenderFns } from "./birthDetail.vue?vue&type=template&id=71ab02ba&scoped=true&"
import script from "./birthDetail.vue?vue&type=script&lang=js&"
export * from "./birthDetail.vue?vue&type=script&lang=js&"
import style0 from "./birthDetail.vue?vue&type=style&index=0&id=71ab02ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab02ba",
  null
  
)

export default component.exports